import {
  IScrollingLibrary,
  ScrollManager as BaseScrollManager,
} from "component-library";

import { SCROLLING_CONTAINER_ID } from "config/common";

export class ScrollManager extends BaseScrollManager {
  private scrollingContainerId: string;
  private scrollPositions: number[] = [];
  private shouldRestore: boolean = false;

  constructor(scrollingContainerId: string, lib?: IScrollingLibrary) {
    super(scrollingContainerId, lib);
    this.scrollingContainerId = scrollingContainerId;
  }

  public reset(): void {
    this.scrollToTop();
  }

  public restore(): void {
    if (!this.shouldRestore) {
      return;
    }

    const position = this.scrollPositions.pop();

    if (position != null) {
      this.scrollTo(position, 0);
    }

    this.shouldRestore = false;
  }

  public save(shouldSavePosition: boolean) {
    if (shouldSavePosition) {
      const el = document.getElementById(this.scrollingContainerId);
      this.scrollPositions.push(el ? el.scrollTop : 0);
    }

    this.shouldRestore = !shouldSavePosition;
  }

  public getLastScrollPosition() {
    return this.scrollPositions.slice(-1)[0];
  }

  public getShouldRestore() {
    return this.shouldRestore;
  }
}

export default new ScrollManager(SCROLLING_CONTAINER_ID);
